import { generateBaseAwsConfig } from "./shared";
import * as stagingConfig from "./staging";
import * as prodConfig from "./prod";

const environment = import.meta.env.VITE_ENV;
const localLambda = import.meta.env.VITE_LOCAL_LAMBDA_PORT;

const { awsAuth, lambdaBaseUrl, graphqlBaseUrl, stripeKey } =
  // use production config if env var is set
  environment === "production" ? prodConfig : stagingConfig;

const awsConfig = {
  Auth: awsAuth,
  ...generateBaseAwsConfig(
    localLambda ? `http://localhost:${localLambda}` : lambdaBaseUrl,
    graphqlBaseUrl,
  ),
};

export { awsConfig, stripeKey };
